<template>
  <modal name="modal-linkcard-name"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="460"
        height="auto"
        @before-open="beforeOpen" >
        
    <div class="modal_wrapper" style="background-color: #ededed;">
       <div slot="top-right">
            <button @click="$modal.hide('modal-linkcard-name')" class="ngdialog-close"></button>
        </div>
        <div class="form-group mt30">
            <div class="input-group">
                <h4 class="input-add-on c_primary mt5 mb-0 mr10" style="font-weight: 300;">Name</h4>
                <client-only><input class="form-control" v-validate="'required'" name="name" type="text" maxlength="50" v-model="linkcard.info.nombre_landing" placeholder="Name" :class="{ 'is-invalid': errors.has('name') }"></client-only>
                <span class="input-group-btn">
                    <button class="btn btn-primary btn-initial text-uppercase" style="border-radius: 0;" @click="updateLinkcardName()">Accept</button>
                </span>
            </div>
            <client-only><div v-if="errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div></client-only>
        </div>
    </div>
  </modal>
</template>

<script>
export default {
    data() {
      return {
          getUser: null,
          linkcard: {
              info: {
                  nombre_landing: '',
                  nombre: ''
              }
          }
      }
    },
    created() {
        this.getUser = this.$store.state.userProfile;
    },
    methods: {
        beforeOpen(event) {
            if(event && event.params && event.params.linkcard) {
                this.linkcard = JSON.parse(JSON.stringify(event.params.linkcard));
                
                if(!this.linkcard.info.nombre_landing) {
                    this.linkcard.info.nombre_landing = this.linkcard.info.nombre || '';
                }
            } else {
                console.warn("no se recibieron parametros o falta linkcard");
            }
        },
        
       async updateLinkcardName() {
            var dis = this;
            
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    const updatedLinkcard = JSON.parse(JSON.stringify(dis.linkcard));
                    dis.$modal.hide('modal-linkcard-name');
                    
                    
                    const index = this.$parent.$parent.linkcardsFiltered.findIndex(
                        item => item.id === updatedLinkcard.id
                    );
                    
                    if (index !== -1) {
                        this.$parent.$parent.linkcardsFiltered[index].info.nombre_landing = updatedLinkcard.info.nombre_landing;
                        
                        // forzar actualizacion de la vista
                        this.$parent.$parent.$forceUpdate();
                    }
                    
                    await this.$util.guardarLinckardGeneral(updatedLinkcard);
                    
                    dis.$util.notif_success("Linkcard guardada correctamente");
                    
                } else {
                    console.warn("validacion fallida");
                }
            }).catch(error => {
                console.error("error al actualizar linkcard:", error);
               dis.$util.notif_error("Error al actualizar linkcard")
            });
        }
    }
}
</script>

<style>
  .modal_wrapper {
    padding: 10px;
    font-style: 13px;
    border-radius: 5px;
  }
</style>